import { formatDimension, formatQuantityValue, parseFloatValue } from "../../../../../helpers/unitOfMeasurementHelpers";

export const searchColumns = [
  { keyName: "productName" },
  { keyName: "dimension", formatRowData: formatDimension },
  { keyName: "planningStatus.quantity", formatRowData: formatQuantityValue },
  { keyName: "productionStatus.quantity", formatRowData: formatQuantityValue },
  { keyName: "shipmentStatus.quantity", formatRowData: formatQuantityValue }
];

export const sortColumns = [
  { keyName: "productName" },
  { keyName: "dimension", formatRowData: formatDimension },
  { keyName: "planningStatus.quantity.value", formatRowData: parseFloatValue },
  { keyName: "productionStatus.quantity.value", formatRowData: parseFloatValue },
  { keyName: "shipmentStatus.quantity.value", formatRowData: parseFloatValue }
];



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Products/ListColumns.js